module.exports = __webpack_public_path__ + "static/requirement-sup-b3bf4cbf93687e049fb3c8b2e1e026f2.svg";